import PropTypes from 'prop-types';

const Chip = ({ item, variant, size, onClick, onRemove }) => {
  if (!item) return null;

  const label = item.name || item.title;
  const key   = item.slug || item.url;

  const colorStyle = item.color ? {
    '--chip-bg':     `${item.color}14`,
    '--chip-border': `${item.color}40`,
    '--chip-text':   item.color,
  } : {};

  const isInteractive = variant === 'interactive';
  const isDismissible = variant === 'dismissible';
  const isStatic      = variant === 'static';

  const sizeClass    = size === 'md' ? 'chip-md' : '';
  const variantClass = isInteractive ? 'chip-interactive'
                     : isDismissible ? 'chip-dismissible'
                     : 'chip-static';

  const handleClick   = isInteractive && onClick ? () => onClick(key) : undefined;
  const handleKeyDown = isInteractive && onClick
    ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(key); } }
    : undefined;

  const Tag = isStatic ? 'span' : 'button';

  return (
    <Tag
      type={isStatic ? undefined : 'button'}
      className={`chip ${variantClass} ${sizeClass}`}
      style={colorStyle}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      title={item.description || label}
      aria-label={isInteractive ? `View: ${label}` : undefined}
    >
      {item.icon && (
        <span className="chip__icon" aria-hidden="true">
          {item.icon}
        </span>
      )}
      <span className="chip__label">{label}</span>
      {isDismissible && (
        <button
          type="button"
          className="chip__remove"
          onClick={(e) => { e.stopPropagation(); onRemove?.(key); }}
          aria-label={`Remove ${label}`}
        >
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
            <path d="M8 2L2 8M2 2l6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      )}
    </Tag>
  );
};

Chip.propTypes = {
  item: PropTypes.shape({
    id:          PropTypes.number,
    name:        PropTypes.string,
    title:       PropTypes.string,
    slug:        PropTypes.string,
    url:         PropTypes.string,
    icon:        PropTypes.node,
    color:       PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  variant:  PropTypes.oneOf(['interactive', 'static', 'dismissible']),
  size:     PropTypes.oneOf(['sm', 'md']),
  onClick:  PropTypes.func,
  onRemove: PropTypes.func,
};

Chip.defaultProps = {
  variant:  'interactive',
  size:     'sm',
  onClick:  null,
  onRemove: null,
};

export default Chip;